import { render, staticRenderFns } from "./showHeader-editor.vue?vue&type=template&id=c9e7bf04&scoped=true"
import script from "./showHeader-editor.vue?vue&type=script&lang=js"
export * from "./showHeader-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e7bf04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9e7bf04')) {
      api.createRecord('c9e7bf04', component.options)
    } else {
      api.reload('c9e7bf04', component.options)
    }
    module.hot.accept("./showHeader-editor.vue?vue&type=template&id=c9e7bf04&scoped=true", function () {
      api.rerender('c9e7bf04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/showHeader-editor.vue"
export default component.exports